import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fr from 'vuetify/es5/locale/fr'
import defaultLightTheme from '@/plugins/themes/defaultLightTheme'
import defaultDarkTheme from '@/plugins/themes/defaultDarkTheme'

Vue.use(Vuetify, {
  iconfont: 'mdi'
})

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: defaultLightTheme,
      dark: defaultDarkTheme
    }
  },
  lang: {
    locales: { fr },
    current: 'fr'
  }
})
